import React, { FC } from 'react'
import { useLocalStorage } from 'react-use'

// Constants
import { routes } from '@sketch/constants'

// Components
import { LinkItem } from 'modules/projects/components/Item'
import NewFeatureHighlightPopover from 'components/NewFeatureHighlightPopover'

// Icons
import { ReactComponent as ControlIcon } from '@sketch/icons/control-color-well-16-svg'

interface PublicProfileSidebarItemProps {
  workspaceId: string
}

export const PublicProfileSidebarItem: FC<PublicProfileSidebarItemProps> = ({
  workspaceId,
}) => {
  const [publicProfileSeen, setPublicProfileSeen] = useLocalStorage(
    'public_profile_ready_seen',
    false
  )

  const handleItemClick = () => {
    setPublicProfileSeen(true)
  }

  return (
    <LinkItem
      icon={{
        icon: ControlIcon,
        highlight: !publicProfileSeen,
      }}
      text="Public Profile"
      to={routes.WORKSPACE_PROFILE_EDIT.create({ workspaceId })}
      showActionsOnHover
      onClick={handleItemClick}
      action={
        <NewFeatureHighlightPopover
          highlightPlacement="sidebar"
          titleText="Your Public Profile is Ready"
          bodyText="Showcase and share designs by adding them to the Workspace public profile."
          buttonLinkProps={{
            to: routes.WORKSPACE_PROFILE.create({ workspaceId }),
            children: 'View Profile',
            variant: 'primary',
          }}
          localStorageKey="publicProfileReadySeen"
        />
      }
    />
  )
}
